import { createPersistedState } from "pinia-plugin-persistedstate";

export default defineNuxtPlugin((nuxtApp) => {
  // @ts-expect-error fixme
  nuxtApp.$pinia.use(createPersistedState());
});
